import { defineMessages } from 'react-intl'

export default defineMessages({
  assignTitle: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.assignTitle',
    defaultMessage: 'Add Task Supplier',
  },
  reAssignTitle: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.reAssignTitle',
    defaultMessage: 'Reassign supplier',
  },
  briefTemplateVO: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.templates.voiceover',
    defaultMessage: `
Check production information for important info!

Style:

Reference file:

Pronunciation:

Recording pace:

Recording specifics:
    `,
  },
  briefTemplateLSA: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.templates.livesessionaudio',
    defaultMessage: `
Hi,

We will do the online live session on XXX. You'll receive an invite in your calendar with a link to join.

Please join 5-10 mins before, so that we can check the sound before the client arrives.

The session will take place at your end as usual, and once the session is completed you need to clean and upload your files in the system as you would for any other job.
Please make sure not to share any personal details or contact info with the client. All file exchange and further communication will be handled through the VoiceArchive platform.

If you have any questions, please feel free to reach out to me anytime.

Talk to you on XXX

Best,
{name}
    `,
  },
  briefTemplateLSP: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.templates.livesessionplayback',
    defaultMessage: `Hello,
We will be holding the Live Session Playback on XXXXX. A link to join the session will be sent to you in a separate email. Please log in 5-10 minutes before the session begins to ensure your connection is working properly.
It is important that you log into the session using your VoiceArchive userid - not your own name.

As this is an Live Session Playback, our audio engineer will connect with your recording setup before we start. We will use the link you receive to establish this connection. If you haven't done this before, please let me know.

For Sessions with Video:
If your session involves running a video, please ensure that the computer displaying the video is in the same room as your microphone.

If you have any questions, feel free to reach out. Otherwise, we'll talk during the session.`,
  },
  briefTemplateUSAGE: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.templates.usage',
    defaultMessage: `
Hi,

This is the 'Usage' task valid for the conditions stated in the left-hand sidebar.

By approving this task, you acknowledge and accept these terms.

**Note that you need to approve this task to receive your payment.**

Best,
{name}
    `,
  },
  briefTemplateNAP: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.templates.briefTemplateNAP',
    defaultMessage: `
Hi,

We have a new Native Audio Post session for you.
The session will take place at XXX
Please login 10 minutes before the session to make sure that the connection is working.
We will send you login details to the session in a separate email.

You will be the Native Audio Engineer on this session together with the talent and client.

Have a good session

Best regards,
{name}
    `,
  },
  briefTemplateLANG_SUP: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.templates.briefTemplateLANG_SUP',
    defaultMessage: `
Hello,
This is your task for attending the Live session on XXXXX as a Language Supervisor.

A link to join the session will be sent to you in a separate email. Please log in 5 minutes before the session begins to ensure your connection is working smoothly.
Please make sure to log in using your VoiceArchive user ID – not your personal name.

As the Language Supervisor, your role is to attend the session and advise on any translation in your native language that could be improved etc..

Please approve this task to make sure your payment will come through.

If you have any questions before the session, feel free to reach out.

Best regards,
{name}
    `
  },
  briefTemplateAD: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.templates.briefTemplateAD',
    defaultMessage: `
Hello,
This is your task for recording the Audio Description for the attached video/script.

Please follow the time codes in the script closely - the description must fit within the gaps in the original audio.

Deliver the recording as separate files per description segment unless stated otherwise, and upload them here in our system when done.

Please approve this task to confirm that you can deliver according to the terms and deadline.

If you have any questions before you start, feel free to reach out.

Best regards,
{name}
    `
  },
  supplierIsUnavailable: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.supplierIsUnavailable',
    defaultMessage: `Supplier has unavailability registered:
{unavailability}
    `,
  }
})
